var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.readOnly)?_c('TaskQueueAction'):_vm._e(),_c('button',{on:{"click":_vm.getTaskQueues}},[_vm._v("Refresh Queues")]),(!_vm.readOnly)?_c('DataInput',{attrs:{"label":"N tasks to ACK","width":"8%"},model:{value:(_vm.numberToAck),callback:function ($$v) {_vm.numberToAck=_vm._n($$v)},expression:"numberToAck"}}):_vm._e(),_c('DataTable',{attrs:{"rowKeys":['id'],"rows":_vm.taskQueues,"actions":!_vm.readOnly
        ? [
            {
              name: 'ackAllTasks',
              label: 'Ack ' + _vm.numberToAck + ' Tasks',
              function: _vm.actionAckAllTasks
            }
          ]
        : [],"columns":[
      { name: 'queueName', type: 'text' },
      { name: 'domain', type: 'text' },
      { name: 'size', type: 'text' },
      { name: 'uacked', type: 'text' },
      { name: 'workerId', type: 'text' },
      { name: 'lastPollTime', type: 'date' }
    ]}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }